// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton_IconButton__-YART","IconButton__Tooltip":"IconButton_IconButton__Tooltip__0A1f+","IconButton--disabled":"IconButton_IconButton--disabled__cSXaa"};